<mat-card class="cur-card" formGroupName="supplyresumptionResultInfo">

    <mat-card-header>
        <mat-card-title>安全周知対象消費機器一覧</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="setsubiNo">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:66px">設備No.</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.setsubiNo}}</td>
                </ng-container>

                <ng-container matColumnDef="consumptiondeviceModelname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:150px">機種</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.consumptiondeviceModelname}}</td>
                </ng-container>
                <ng-container matColumnDef="manufactureYm">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:75px">製造年月</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.manufactureYm | dateYmStringSg}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ventilationHoshikiMei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:150px">給排気方式
                    </th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.ventilationHoshikiMei}}</td>
                </ng-container>

                <ng-container matColumnDef="cnnctJokyoMei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:150px">接続</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.cnnctJokyoMei}}</td>
                </ng-container>

                <ng-container matColumnDef="saleKeitaiMei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:85px">販売</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.saleKeitaiMei}}</td>
                </ng-container>

                <ng-container matColumnDef="manufacturerMei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:150px">メーカー</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.manufacturerMei}}</td>
                </ng-container>

                <ng-container matColumnDef="model">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:150px">型式</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.model}}</td>
                </ng-container>

                <ng-container matColumnDef="installationlocationMei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:85px">設置場所</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.installationlocationMei}}</td>
                </ng-container>

                <ng-container matColumnDef="nonconformityCode">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:40px">不適合<br>コード
                    </th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.nonconformityCode}}</td>
                </ng-container>

                <ng-container matColumnDef="covalueMei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:40px">CO値</th>
                    <td mat-cell class="mat-cell-left" *matCellDef="let row">{{row.covalueMei}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol;sticky:true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
            </table>
        </div>
    </mat-card-content>

    <div class="tw-flex tw-flex-row tw-flex-wrap" style="margin-bottom: 20px;"
        *ngIf="getControl('unsafeDeviceNoticeflag')?.enabled">
        <mat-radio-group color="warn"
            class="search-condition-radio-framew-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[400px] tw-max-w-[400px] tw-min-w-[400px]"
            style="height: 50px; position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
            <mat-label
                style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                安全周知 *</mat-label>
            <mat-checkbox class="check-box" color="primary" [checked]="unsafeDeviceNoticeflag"
                (change)="unsafeDeviceNoticeflag = $event.checked" id="unsafeDeviceNoticeflag"
                style="margin-left: 15px; margin-top: 15px;">非安全機器・給排気設備不良機器周知
            </mat-checkbox>
        </mat-radio-group>
    </div>

    <div class="tw-flex tw-flex-row tw-flex-wrap" style="margin-bottom: 20px;">
        <mat-radio-group id="workPlace" name="workPlace" color="warn" formControlName="lightingExaminedFlg"
            [value]="lightingExaminedFlgValue"
            class="search-condition-radio-frame tw-flex-row box-border tw-grow tw-shrink tw-basis-[340px] tw-max-w-[340px] tw-min-w-[340px]"
            style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
            <mat-label
                style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                点火試験 *</mat-label>
            <mat-radio-button class="radio-button-margin" [value]="code.userCode"
                *ngFor="let code of codeMap?.get('S301380')">{{code.hyojiCont}}</mat-radio-button>
        </mat-radio-group>
    </div>
</mat-card>